module.exports = __webpack_public_path__ + "img/img_intro_2_deco6.6a6a29e1.png";